module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('logo-in-header', {
    staticClass: "pull-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-phone pull-right"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('index')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-list nickname-li"
  }, [_c('router-link', {
    staticClass: "nickname",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.nickName) + "\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v(_vm._s(_vm.$t('settings')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/affiliate"
    }
  }, [_vm._v(_vm._s(_vm.$t('invitationRecords')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/recharge"
    }
  }, [_vm._v(_vm._s(_vm.$t('topUpRecords')))])], 1), _vm._v(" "), (_vm.showCommission) ? _c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/commission"
    }
  }, [_vm._v(_vm._s(_vm.$t('affiliate')))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "menu-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/device-management"
    }
  }, [_vm._v(_vm._s(_vm.$t('device_manage')))])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('signOut')) + "\n        ")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fold-navigation",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-label": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home/h5_header_btn.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71501ee6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/userCenterHeader/UserCenterHeaderM.vue
// module id = 1351
// module chunks = 1